import React from "react";
import styled from "styled-components";
import { colors } from "../../../utils";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';

const Wrapper = styled.div`
  padding: 5px;
  width: 260px;
  position: relative;
`;

const Input = styled.input`
  border: 1px solid #CED4DA;
  outline: none;
  background-color: ${colors.white};
  padding: 10px 16px;
  border-radius: 8px;
  padding-left: ${props => props.moveIcon ? '35px' : '16px'};

  &::placeholder {
    color: #212529;
  }

    ${({ moveIcon }) =>
    moveIcon &&
    `
    &::before {
      content: "'Hello'";
      position: absolute;
      left: 16px;
      color: ${colors.lightGrey};
      font-size: 16px;
    }
  `}
`;

const SearchInput = ({ value, handleChange, handleKeyPress, handleCancel, showSearchIcon = true, moveIcon = false }) => {
  return (
    <Wrapper>
      {moveIcon && (
        <SearchIcon 
          style={{ 
            color: colors.lightGrey, 
            position: 'absolute', 
            left: 15, 
            top: 17 
          }} 
        />
      )}
      {showSearchIcon && !moveIcon && <SearchIcon style={{ color: colors.lightGrey, marginRight: 3 }} />}
      <Input
        type="text"
        value={value}
        onChange={handleChange}
        placeholder="Search"
        onKeyPress={handleKeyPress}
        moveIcon={moveIcon}
      />
      {value!=="" &&   <CloseIcon style={{ position: "absolute", color: colors.lightGrey, right: "45px", top: "15px" }} onClick={handleCancel}/>}
    </Wrapper>
  );
};

export default SearchInput;
